import Activities from "./components/Activities";

const AllActivities = () => <Activities />

export default AllActivities;